import Clarity from "@microsoft/clarity";

export const initClarity = (): void => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  if (!projectId) return;

  Clarity.init(projectId);
};
